<template>
  <div :id="mapId" style="position: relative; height: 100%;"></div>
</template>

<script>
import MapBoxGL from "mapbox-gl";
import hull from "hull.js";
import { getCenterPoint } from "../../utils/calcCenterPoint";
import treeImg from "../../assets/img/map-tree.png";
// import * as turf from '@turf/turf'
import TreeType from "../../api/TreeType";

export default {
  name: "MapBoxItemComponent",

  props: {
    areaData: {
      required: false,
      type: Object
    },
    mapId: {
      required: false,
      type: String,
      default: "map"
    },
    selectedPerimeters: {
      required: false,
      type: Array
    },
    provider: {
      required: false,
      type: String,
      default: "mapbox" // "mapbox" | "mml"
    }
  },
  watch: {
    area: function() { // watch it
      this.createMap();
    },
    selectedPerimeters: {
      handler() {
        if (this.map && this.map.loaded()) {
          this.createMap();
        }
      },
      deep: true
    },
    provider() {
      this.createMap();
    }
  },
  data() {
    return {
      accessToken: "pk.eyJ1IjoibWFnaW9kZXYiLCJhIjoiY2t3YzdjZ2ltMWZlczJ3cDJubXFheHl0bSJ9.B1spSbf4EfBOlDhYVmRZMQ",
      container: "map", // container ID
      mapboxStyle: "mapbox://styles/josedvd123/ckyubv4uz001v14lcg26hetvw", // style URL
      zoom: 15.5, // starting zoom
      map: {},
      allAreaTreesCoordinates: []
    };
  },
  computed: {
    style() {
      if (this.provider === "mml" || this.provider === "mml-topo") {
        // The MML (Maanmittauslaitos) WMTS services are plugged in as plain
        // raster tile sources — Mapbox GL only cares that a style has
        // sources/layers, it doesn't need to be Mapbox's own hosted style,
        // so all the tree-marker layers added in addLayers() below work
        // identically regardless of which base map is showing.
        // "mml" = aerial orthophoto ("ortokuva"); "mml-topo" = the Finnish
        // topographic map ("maastokartta"), which — unlike the aerial photo —
        // also renders cadastral/property boundaries and parcel numbers,
        // which is what forestry professionals actually want to see.
        const apiKey = process.env.VUE_APP_MML_API_KEY;
        const isTopo = this.provider === "mml-topo";
        const defaultTemplate = isTopo
          ? "https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts?api-key={apiKey}&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=maastokartta&STYLE=default&TILEMATRIXSET=WGS84_Pseudo-Mercator&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/png"
          : "https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts?api-key={apiKey}&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ortokuva&STYLE=default&TILEMATRIXSET=WGS84_Pseudo-Mercator&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/jpeg";
        const tileTemplate = (isTopo
          ? process.env.VUE_APP_MML_TOPO_WMTS_URL_TEMPLATE
          : process.env.VUE_APP_MML_WMTS_URL_TEMPLATE) || defaultTemplate;
        const tileUrl = tileTemplate.replace("{apiKey}", apiKey || "");
        return {
          version: 8,
          sources: {
            mml: {
              type: "raster",
              tiles: [tileUrl],
              tileSize: 256,
              attribution: "© Maanmittauslaitos"
            }
          },
          layers: [{ id: "mml-base", type: "raster", source: "mml" }]
        };
      }
      return this.mapboxStyle;
    }
  },

  mounted() {
    this.container = this.mapId || "map";
    this.createMap();
  },

  methods: {
    async createMap() {

      console.log(this.areaData, "this.areaDataaaaaaaaaaaaa");

      if (this.areaData) {
        let allAreaTreesCoordinates = [];
        for (const treeType of this.areaData.treeTypes) {
          allAreaTreesCoordinates = allAreaTreesCoordinates
            .concat(
              treeType.trees
                .map(tree => [tree.lng, tree.lat])
            );
        }
        this.allAreaTreesCoordinates = allAreaTreesCoordinates;

        this.areaData.centerPoint = getCenterPoint(allAreaTreesCoordinates);

        MapBoxGL.accessToken = this.accessToken;

        if (this.map && typeof this.map.remove === "function") {
          this.map.remove();
        }

        this.map = new MapBoxGL.Map({
          container: this.container,
          style: this.style,
          center: this.areaData.centerPoint,
          zoom: this.zoom,
          attributionControl: false,
          preserveDrawingBuffer: true
        });

        this.addLayers();
      }
    },
    addLayers() {
      this.map.on("render", () => {
        this.map.resize();
      });
      this.map.on("load", () => {
        this.centerPoints();
        this.map.loadImage(treeImg, async (error, image) => {
          if (error) throw error;

          this.map.addImage("tree-icon", image);

          console.log(this.areaData.treeTypes, "TEST!!!!");
          let allAreaTreesCoordinates = [];
          for (const treeType of this.areaData.treeTypes) {
            const res = await TreeType.getTreeTypes(treeType.id);
            const areaTreeType = res.data?.data || res.data;
            const ref = treeType.reference;

            allAreaTreesCoordinates = allAreaTreesCoordinates
              .concat(
                treeType.trees
                  .map(tree => [tree.lng, tree.lat])
              );


            let features = treeType.trees.map((tree) => {
              return {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [tree.lng, tree.lat]
                }
              };
            });


            this.map.addSource("forests-source" + ref, {
              type: "geojson",
              data: {
                type: "FeatureCollection",
                features
              }
            });

            this.map.addLayer({
              id: "forests" + ref,
              source: "forests-source" + ref,
              type: "circle",
              paint: {
                "circle-color": areaTreeType?.color || "#42b883",
                "circle-radius": 2
              }
            });
          }


          let perimeterCoordinates = hull(
            allAreaTreesCoordinates,
            2);

          this.map.addSource("perimeter-source", {
            "type": "geojson",
            "data": {
              "type": "Feature",
              "geometry": {
                "type": "Polygon",
                "coordinates": [
                  perimeterCoordinates
                ]
              }
            }
          });


          // this.map.addLayer({
          //   'id': 'perimeter',
          //   'type': 'fill',
          //   'source': 'perimeter-source', // reference the data source
          //   'layout': {},
          //   minzoom: 11,
          //   maxzoom: 13,
          //   'paint': {
          //     'fill-color': '#42b883', // blue color fill
          //     'fill-opacity': 0.2
          //   }
          // });

          // this.map.addLayer({
          //   'id': 'outline',
          //   'type': 'line',
          //   'source': 'perimeter-source',
          //   'layout': {},
          //   minzoom: 11,
          //   maxzoom: 13,
          //   'paint': {
          //     'line-color': '#0a7045',
          //     'line-width': 3
          //   }
          // });


          // const coordinatesArea = +(turf.area({
          //   'type': 'Feature',
          //   'geometry': {
          //     'type': 'Polygon',
          //     'coordinates': [
          //       perimeterCoordinates
          //     ]
          //   }
          // }) / 10000).toFixed(2);


          // this.map.addSource('area-source', {
          //   'type': 'geojson',
          //   'data': {
          //     'type': 'FeatureCollection',
          //     'features': [
          //       {
          //         'type': 'Feature',
          //         'geometry': {
          //           'type': 'Point',
          //           'coordinates': this.areaData.centerPoint
          //         },
          //         "properties": {
          //           "area": coordinatesArea,
          //           "trees": allAreaTreesCoordinates.length
          //
          //         }
          //       }
          //     ]
          //   }
          // });


          // this.map.addLayer({
          //   "id": "area-units",
          //   "type": "symbol",
          //   minzoom: 11,
          //   maxzoom: 13,
          //   "source": "area-source",
          //   "layout": {
          //     "symbol-placement": "point",
          //     "text-font": ["Open Sans Bold"],
          //     "text-field": '{trees} trees\n{area} ha', // part 2 of this is how to do it
          //     "text-size": 12,
          //   },
          //   'paint': {
          //     'text-color': '#0a7045'
          //   },
          // });

          // this.map.addLayer({
          //   'id': 'area',
          //   'type': 'symbol',
          //   maxzoom: 11,
          //   'source': 'area-source', // reference the data source
          //   'layout': {
          //     'icon-image': 'tree-icon', // reference the image
          //     'icon-size': 0.2
          //   }
          // });


          for (const i in this.areaData.perimeters) {
            // Solo procesar si el índice está en selectedPerimeters
            if (this.selectedPerimeters && this.selectedPerimeters.includes(i)) {


              let geometry = this.areaData.perimeters[i];

              console.log({ geometry });

              this.map.addSource(`perimeter-src${i}`, {
                "type": "geojson",
                "data": {
                  "type": "Feature",
                  geometry
                }
              });

              this.map.addLayer({
                "id": `perimeter-line${i}`,
                "type": "line",
                "source": `perimeter-src${i}`,
                minzoom: 11,
                "layout": {},
                "paint": {
                  "line-color": "#000",
                  "line-width": 2
                }
              });
            }
          }
        });
      });
    },

    centerPoints() {
      let bounds = new MapBoxGL.LngLatBounds();
      this.allAreaTreesCoordinates.forEach(coord => {
        bounds.extend(coord);
      });

      this.map.fitBounds(bounds, {
        padding: { top: 12, bottom: 12, left: 12, right: 12 }
      });
    }
  }
};
</script>

<style scoped>

</style>
